/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {sendChatSideEffects} from '../api'

export const useMutationSendChatSideEffects = createReactQueryMutationHook('sendChatSideEffects', sendChatSideEffects)
